<div id="container-router">
  <div class="favorites-tracks container-fluid inner-component-container">
    <div class="col-lg-12 data-table">
      <table>
        <tr *ngFor="let rowArray of data">
          <td class="col-lg-4" *ngFor="let item of rowArray">
            <div class="cell-content">
              <div *ngIf="item.name">
                <a [routerLink]="['/', linkPath1, linkPath2, item.id, 'list']"
                   [ngClass]="{'disabled': (item.enabled === false)}" attr.aria-label="{{ariaItemLabel}}: {{item.name}}">{{item.name}}</a>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
